import React, { useContext } from "react";

import {
  Divider,
  Grid,
  Button
} from "@material-ui/core";
import DirectionsIcon from "@material-ui/icons/Directions";
import PercentComputationHelper from "./tools/PercentComputationHelper";
import { PageContext } from "../../contexts/PageContext";
import { getMonthsBetween } from "../../functions/GlobalHelpers"


export default function CreditFieldGroupVorlast(
  {
    renderCreditField,
    creditFunctions,
    index
  }) {

  const pageContext = useContext(PageContext);

  return (
    <>
      {renderCreditField("__vorlast" + index + "__kreditnehmer", 6, 4)}
      {renderCreditField("__vorlast" + index + "__vorbelastung_fuer", 12, 8)}
      {renderCreditField("__vorlast" + index + "__institut", 6, 4)}
      {renderCreditField("__vorlast" + index + "__iban", 6, 4, "iban")}
      {/* {renderCreditField("__vorlast" + index + "__betrieblicher_kredit", 12, 4)} */}
      {renderCreditField("__vorlast" + index + "__zukunft", 12, 4)}
      {renderCreditField("__vorlast" + index + "__besichert_auf_liegenschaft", 12, 6)}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__vorlast" + index + "__urspr_kreditbetrag", 6, 3, "euro")}
      {renderCreditField("__vorlast" + index + "__monatliche_rate", 6, 3, "euro")}
      {renderCreditField("__vorlast" + index + "__aktuelle_aushaftung", 6, 3, "euro")}
      {renderCreditField("__vorlast" + index + "__kreditaufnahme", 6, 3)}
      {renderCreditField("__vorlast" + index + "__urspr_laufzeit", 12, 6, "months")}
      <Grid item xs={12} md={6} />
      {renderCreditField("__vorlast" + index + "__restlaufzeit", 12, 6, "months")}
      <Grid item xs={6} md={6}>
        <Button
          size="small"
          onClick={() => {
            const total_months = parseInt(creditFunctions.getFirstValueByMetaKey("__vorlast" + index + "__urspr_laufzeit"));
            const start_date = creditFunctions.getFirstValueByMetaKey("__vorlast" + index + "__kreditaufnahme");
            if (total_months > 0 && start_date) {
              const today = new Date();
              if (start_date > today) {
                pageContext.setInfoMessage("Die Kreditaufnahme liegt in der Zukunft, die Restlaufzeit ist also die Gesamtlaufzeit.");
                creditFunctions.setValuesByMetaKey("__vorlast" + index + "__restlaufzeit", total_months);
                creditFunctions.setValuesByMetaKey("__vorlast" + index + "__zukunft", true);
              } else {
                const month_diff = getMonthsBetween(start_date, today, false);
                const remaining_months = total_months - month_diff;
                if (month_diff > 0 && remaining_months > 0) {
                  creditFunctions.setValuesByMetaKey("__vorlast" + index + "__restlaufzeit", remaining_months);
                } else {
                  pageContext.setErrorMessage("Ich konnte keine Restlaufzeit berechnen.");
                }
              }
            } else {
              pageContext.setErrorMessage("Bitte fülle zuerst die ursprüngliche Laufzeit und das Startdatum aus um die Restlaufzeit zu berechnen.");
            }
            console.log(total_months, start_date);
          }}
        >
          <DirectionsIcon />
          berechnen
        </Button>
      </Grid>
      {renderCreditField("__vorlast" + index + "__umschuldung_erwuenscht", 12, 4)}
      {renderCreditField("__vorlast" + index + "__umschuldung_poenale", 7, 5, "pricetable")}
      <Grid item xs={5} md={3}>
        <PercentComputationHelper
          title="Pönale"
          description="Falls eine Pönale anfällt, bitte hier eintragen. Typischerweise beträgt diese 1% des Restkreditbetrags."
          sourceKey={["__vorlast" + index + "__aktuelle_aushaftung"]}
          targetKey={"__vorlast" + index + "__umschuldung_poenale"}
          defaultPercent={1.0}
          showOptionalTax={false}
          creditFunctions={creditFunctions}
        />
      </Grid>
      {renderCreditField("__vorlast" + index + "__abloesung_durch_eigenkapital", 12, 4)}
      {renderCreditField("__vorlast" + index + "__leasingrate_nachgewiesen", 12, 4)}
      {/* {renderCreditField("__vorlast" + index + "__kreditnehmer_bedient_rate_nicht", 12, 6)} */}
    </>
  );
}
